import React from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";

import IconText from "../components/iconText/iconText";
import MediaGalleryItem from "../components/mediaGallery/mediaGalleryItem";
import { ReactComponent as IconDownload24 } from "../icons/icon/24/a-icon-download-24.svg";
import mapKontentItem from "../utils/mapKontentItem";
import SimpleRichText from "./text/simpleRichText";

const KontentItemMediaGalleryItems = ({ data }) => {
  const mediaItems = Array.isArray(data) ? data : data.value;

  const itemsList = [];

  mediaItems.forEach((mediaItem) => {
    itemsList.push(
      <MediaGalleryItem
        headline={mediaItem.elements.title.value}
        description={(<SimpleRichText data={mediaItem.elements.short_description} />)}
        download={mediaItem.elements.download.value.length > 0
        && mediaItem.elements.download.value[0].elements.asset_item.value.length > 0
          ? (
            <a
              download
              href={mediaItem.elements.download.value[0].elements.asset_item.value[0].url}
              className="no-style"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconText
                icon={<IconDownload24 />}
                variant="light"
                text={mediaItem.elements.download.value[0].elements.title.value}
              />
            </a>
          )
          : null}
        media={mediaItem.elements.image_or_video.value.length > 0
          ? mapKontentItem(mediaItem.elements.image_or_video.value[0], {
            height: 160,
            noLength: true,
            noTitle: true,
            variant: "16by9",
            width: 280,
          })
          : null}
      />,
    );
  });

  return React.Children.toArray(itemsList);
};

export const query = graphql`
  fragment KontentitemMediaGalleryItems on kontent_item_gallery_item {
    id
    system {
      codename
    }
    elements {
      title {
        value
      }
      short_description {
        value
        images {
          width
          url
          image_id
          height
          description
        }
        links {
          link_id
          codename
          type
          url_slug
        }
        type
        name
        modular_content {
          id
          system {
            codename
          }
          internal {
            type
          }
        }
      }
      image_or_video {
        value {
        internal {
          type
        }
          ...KontentItemImage
          ...KontentItemVideoEmbed
        }
      }
      download {
        value {
          ... on kontent_item_asset {
            id
            elements {
              title {
                value
              }
              asset_item {
                value {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`;

KontentItemMediaGalleryItems.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default KontentItemMediaGalleryItems;
